export default {
    searchByEmployeeNameOrID: 'Search by Employee name or ID',
    statusAttendance: 'Status Attendance',
    search: 'Search',
    employeeId: 'Employee ID',
    employeeName: 'Employee Name',
    bureau: 'Bureau',
    date: 'Date',
    locationIn: 'Location (in)',
    checkinTime: 'Check in',
    locationOut: 'Location (out)',
    checkoutTime: 'Check out',
    totalHour: 'Total hour',
    status: 'Status',
    exportTXT: 'Export Text File',
    exportPDF: 'Export PDF',
    exportExcel: 'Export Excel',
    congratulation: 'Congratulation',
    somethingWrong: 'Something went wrong'
}
